export interface CEPData {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
}

export interface CEPError {
  erro: boolean;
}

export class CEPApiUnavailableError extends Error {
  constructor(message: string = 'API do ViaCEP está indisponível') {
    super(message);
    this.name = 'CEPApiUnavailableError';
  }
}

class CEPService {
  private readonly baseURL = 'https://viacep.com.br/ws';
  private readonly timeout = 10000;

  async buscarCEP(cep: string): Promise<CEPData> {
    const cepLimpo = String(cep).replace(/\D/g, '');
    if (cepLimpo.length !== 8) {
      throw new Error('CEP deve ter 8 dígitos');
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), this.timeout);

    try {
      const response = await fetch(`${this.baseURL}/${cepLimpo}/json/`, {
        signal: controller.signal
      });
      if (!response.ok) throw new CEPApiUnavailableError();
      const data: CEPData | CEPError = await response.json();
      if ('erro' in data && data.erro) throw new Error('CEP não encontrado');
      return data as CEPData;
    } catch (fetchError: any) {
      if (fetchError?.name === 'AbortError') throw new CEPApiUnavailableError();
      if (fetchError instanceof TypeError) throw new CEPApiUnavailableError();
      throw fetchError;
    } finally {
      clearTimeout(timeoutId);
    }
  }

  formatarCEP(cep: string): string {
    const cepLimpo = String(cep).replace(/\D/g, '');
    if (cepLimpo.length === 8) {
      return `${cepLimpo.slice(0, 5)}-${cepLimpo.slice(5)}`;
    }
    return cep;
  }

  validarCEP(cep: string): boolean {
    const cepLimpo = String(cep).replace(/\D/g, '');
    return cepLimpo.length === 8;
  }
}

export const cepService = new CEPService();
